<script>
import Navbar from "@/components/landingpage/Navbar.vue";
import Footer from "@/components/landingpage/Footer.vue";
import { http } from "@/services/config";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import authHeader from "@/services/auth-header";
import Hls from "hls.js";
import { useToast } from "vue-toastification";
const toast = useToast();
import { useDisplay } from "vuetify";

export default {
  setup() {
    const { mdAndUp } = useDisplay();

    return { mdAndUp };
  },
  watch: {
    tab(val) {
      if (val === "3") {
        this.$nextTick(() => {
          // Adiciona um pequeno delay para garantir que o DOM está pronto
          setTimeout(() => {
            this.fetchStreamUrl();
          }, 300);
        });
      }
    },
  },
  beforeUnmount() {
    if (this.hls) {
      this.hls.destroy();
      this.hls = null;
    }
  },
  components: { Navbar, Footer },
  data() {
    return {
      rules: {
        required: (v) => !!v || "Este campo é obrigatório",
        nome: (v) =>
          (v && v.length >= 3) || "O nome deve ter pelo menos 3 caracteres",
        email: (v) => {
          if (!v) return true; // Se estiver vazio, retorna válido
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Por favor, insira um e-mail válido";
        },
        telefone: (v) => {
          const numeroLimpo = v.replace(/\D/g, "");
          return (
            numeroLimpo.length === 11 ||
            "O telefone deve ter 11 dígitos (DDD + número)"
          );
        },
      },
      despedida: {},
      falecido: {},
      participante: {
        nome: "",
        telefone: "",
        email: "",
        desejoReceberOfertas: true,
      },
      dialogParticipante: false,
      dialogParticipanteTipo: "",
      isLoadingParticipante: false,
      mensagem: false,
      isLoadingMensagem: false,
      posts: [],
      post_new: {
        img: "",
        msg: "",
        autor: "",
        url: "",
      },
      tab: "1",
      statusMessage: "",
      statusClass: "",
      codigo: null,
      codigoVideoTemp: null,
      streamUrl: "",
      hls: null,
      retryCount: 0,
      id: null,
      transmissaoEncerrada: false,
      transmissaoDesativada: false,
      transmissaoEmBreve: false,
      isLoading: true,
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.codigo = this.$route.params.codigo;
    this.codigoVideoTemp = this.codigo;
    this.despedidas(this.id, this.codigo);
  },
  computed: {
    codigoSalvo() {
      try {
        return (
          this.codigo ||
          (typeof sessionStorage !== "undefined" &&
            sessionStorage.getItem(`codigo_despedida_${this.id}`))
        );
      } catch (e) {
        return this.codigo;
      }
    },
  },
  methods: {
    getFotoPadrao(item) {
      const sexo = item?.pessoa_falecida?.sexo || "Masculino";
      return sexo === "Feminino"
        ? require("@/assets/feminino.png")
        : require("@/assets/masculino.png");
    },
    async enviarMensagem() {
      const cod = sessionStorage.getItem(`codigo_despedida_${this.id}`) || 0;
      if (await this.validarToken(cod)) {
        this.mensagem = true;
        return;
      } else {
        this.dialogParticipante = true;
        this.dialogParticipanteTipo = "mensagem";
      }
    },
    queroParticipar() {
      this.dialogParticipante = true;
      // Limpa os dados do formulário ao abrir
      this.participante = {
        nome: "",
        telefone: "",
        email: "",
        desejoReceberOfertas: true,
      };
    },
    async confirmarParticipante() {
      this.isLoadingParticipante = true;
      try {
        const payload = {
          ...this.participante,
          idDespedida: Number(this.id),
        };
        const response = await http.post("/participantes", payload);
        this.isLoadingParticipante = false;
        this.dialogParticipante = false;
        if (response && response.data && response.data.codigo) {
          this.codigo = response.data.codigo;
          sessionStorage.setItem(
            `codigo_despedida_${this.id}`,
            response.data.codigo
          );
          toast.success("Cadastro realizado com sucesso!");
          if (this.dialogParticipanteTipo == "mensagem") {
            this.mensagem = true;
          }
          this.fetchStreamUrl();
        } else {
          toast.success("Cadastro realizado com sucesso!");
        }
      } catch (error) {
        this.isLoadingParticipante = false;
        toast.error("Erro ao cadastrar participante!");
      }
    },

    showStatus(message, isError = false) {
      this.statusMessage = message;
      this.statusClass = isError ? "error" : "loading";
    },

    async fetchStreamUrl() {
      this.showStatus("Buscando URL do stream...");
      let video = document.getElementById("video-player");
      let tentativas = 0;
      // Tentar encontrar o elemento até 10x (até 1s)
      while (!video && tentativas < 10) {
        await new Promise((res) => setTimeout(res, 100));
        video = document.getElementById("video-player");
        tentativas++;
      }
      if (!video) {
        this.showStatus("Elemento de vídeo não encontrado!", true);
        console.error("[HLS] Elemento de vídeo não encontrado!");
        return;
      }
      console.log("[HLS] Elemento de vídeo encontrado", video);
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
      this.retryCount = 0;

      try {
        if (
          !this.despedida ||
          !this.despedida.apresentacao ||
          !this.despedida.apresentacao.camera
        ) {
          this.showStatus("Câmera não encontrada para esta despedida.", true);
          return;
        }
        const camera = this.despedida.apresentacao.camera;
        // Monta a URL considerando o código opcional
        let codigo =
          this.codigo ||
          sessionStorage.getItem(`codigo_despedida_${this.id}`) ||
          this.codigoVideoTemp;

        if (!codigo) {
          // Não faz a requisição se não houver código
          //this.showStatus("É necessário um código de acesso para participar do velório virtual.", true);
          return;
        }
        let url = `api/videos/stream/${camera}?codigo=${codigo}`;
        const response = await http.get(url, {
          headers: authHeader(),
          responseType: "text",
        });
        const resposta =
          response.data && typeof response.data === "string"
            ? response.data.trim()
            : "";
        if (resposta === "Transmissão encerrada") {
          this.transmissaoEncerrada = true;
          this.transmissaoEmBreve = false;
          this.streamUrl = "";
          return;
        } else if (resposta === "Transmissão em breve") {
          this.transmissaoEncerrada = false;
          this.transmissaoEmBreve = true;
          this.streamUrl = "";
          return;
        } else if (resposta === "Transmissão Desativada") {
          this.transmissaoEncerrada = false;
          this.transmissaoEmBreve = false;
          this.transmissaoDesativada = true;
          this.streamUrl = "";
          return;
        } else {
          this.transmissaoEncerrada = false;
          this.transmissaoEmBreve = false;
          this.transmissaoDesativada = false;
        }
        this.streamUrl = response.data;

        if (Hls && Hls.isSupported()) {
          this.hls = new Hls({
            maxMaxBufferLength: 60, // igual
            maxBufferSize: 50 * 1024 * 1024, // 50 MB
            maxBufferLength: 20, // igual ao HTML
            lowLatencyMode: false,
            enableWorker: true,
            backBufferLength: 15, // igual ao HTML
          });

          // (Opcional) Adiciona token aos segmentos, se necessário
          this.hls.on(Hls.Events.FRAG_LOADING, (event, data) => {
            if (
              this.streamUrl &&
              this.streamUrl.includes("token=") &&
              !data.frag.url.includes("token=")
            ) {
              data.frag.url += `&token=${this.streamUrl.split("token=")[1]}`;
            }
          });

          this.hls.loadSource(this.streamUrl);
          this.hls.attachMedia(video);

          this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            this.showStatus("Stream conectado com sucesso!");
            setTimeout(() => (this.statusMessage = ""), 2000);
            video
              .play()
              .catch((e) =>
                this.showStatus("Erro ao reproduzir: " + e.message, true)
              );
            this.retryCount = 0;
          });

          this.hls.on(Hls.Events.ERROR, (event, data) => {
            if (data.fatal) {
              switch (data.type) {
                case Hls.ErrorTypes.NETWORK_ERROR:
                  this.showStatus("Erro de rede, tentando reconectar...", true);
                  break;
                case Hls.ErrorTypes.MEDIA_ERROR:
                  this.showStatus("Erro de mídia, reiniciando...", true);
                  this.hls.recoverMediaError();
                  return;
                default:
                  this.showStatus("Erro fatal, tentando reconectar...", true);
              }
              if (this.retryCount < this.MAX_RETRIES) {
                this.retryCount++;
                setTimeout(this.fetchStreamUrl, this.RETRY_DELAY);
              } else {
                this.showStatus(
                  "Falha ao conectar após várias tentativas. Por favor, recarregue a página.",
                  true
                );
              }
            }
          });
        } else if (
          video &&
          video.canPlayType("application/vnd.apple.mpegurl")
        ) {
          video.src = this.streamUrl;
          video.addEventListener("error", () => {
            this.showStatus("Erro ao carregar o stream", true);
          });
        } else {
          this.showStatus("Seu navegador não suporta reprodução HLS.", true);
        }
      } catch (error) {
        this.showStatus("Erro ao buscar o stream: " + error, true);
      }
    },

    formatDate(date) {
      return dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    async validarToken(codigo) {
      try {
        const response = await http.get("exibicao/validar-codigo", {
          params: {
            despedidaId: this.id,
            codigo: codigo,
          },
        });

        if (response.statusText == "OK" && response.status === 200) {
          this.codigo = codigo;
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    despedidas(idDespedida, token) {
      if (!token) {
        token = 0;
      }
      http
        .get(`exibicao/despedida/${idDespedida}/${token}`)
        .then((response) => {
          this.despedida = response.data;
          this.falecido = this.despedida.pessoa_falecida;
          this.moderador = this.despedida.pessoa_moderador;
          this.consultarMensagens();
          this.isLoading = false;
        })
        .catch((error) => {
          if (
            error?.response?.status === 404 &&
            error?.response?.data === "Despedida não encontrada"
          ) {
            toast.error(`Despedida não localizada!`);
            console.log("Erro 404:", error.response.data);
            this.$router.push("/despedida-status/not-found");
          } else if (
            error?.response?.status === 404 &&
            error?.response?.data === "Despedida privada"
          ) {
            toast.error(`Despedida privada!`);
            this.$router.push("/despedida-status/private");
          } else if (
            error?.response?.status === 404 &&
            error?.response?.data === "Despedida está inativa"
          ) {
            toast.error(`Despedida inativa!`);
            this.$router.push("/despedida-status/inactive");
          } else {
            toast.error("Ocorreu um erro ao buscar a despedida!");
            console.log("Erro:", error);
            this.$router.push("/despedida-status/not-found");
          }
        });
    },
    consultarMensagens() {
      http
        .get("homenagem/homenagem-aprovadas/" + this.id)
        .then((response) => {
          this.posts = response.data;
        })
        .catch((error) => {
          console.error("Erro ao buscar CPF:", error);
        });
    },
    async newMensagem() {
      this.isLoadingMensagem = true;

      try {
        const formData = new FormData();

        formData.append(
          "homenagem",
          new Blob(
            [
              JSON.stringify({
                descricao: this.post_new.msg,
                nome: this.post_new.autor,
                despedida: this.id,
                url: this.post_new.url,
                publicado: true,
              }),
            ],
            { type: "application/json" }
          )
        );

        if (this.post_new.img) {
          formData.append("imagem", this.post_new.img);
        } else {
          formData.append(
            "imagem",
            new Blob([], { type: "application/octet-stream" })
          );
        }

        await http.post("homenagem/homenagem", formData, {
          headers: {
            ...authHeader(),
          },
        });

        this.mensagem = false;
        toast.success("Homenagem sujeita à aprovação!");
      } catch (error) {
        if (error.response && error.response.status !== 200) {
          toast.error("Erro ao enviar mensagem!");
          this.msg_dialog = "Erro ao enviar mensagem!";
        }
      } finally {
        this.isLoadingMensagem = false;
        this.consultarMensagens();
      }
    },

    // Função para converter o arquivo para Base64
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        if (!file || !(file instanceof Blob)) {
          resolve(""); // Retorna string vazia se arquivo inválido
          return;
        }
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
  },
};
</script>

<template>
  <div class="page-container">
    <Navbar />

    <div class="main-content">
      <template v-if="isLoading">
        <div class="loading-container">
          <v-progress-circular
            indeterminate
            color="#343F53"
            size="64"
            width="6"
          ></v-progress-circular>
          <p class="loading-text">Carregando informações...</p>
        </div>
      </template>

      <template v-else>
        <section
          class="banner"
          v-if="despedida && despedida.foto_fundo"
          :style="{
            backgroundImage: `url(${require(`@/assets/pack-banners/${despedida.foto_fundo}.jpg`)})`,
          }"
        >
          <div class="imgperfil">
            <img
              :src="getFotoPerfilUrl(despedida.nome_arquivo_foto_perfil) ||
                  getFotoPadrao(despedida)"
              alt="Foto de Perfil"
            />
          </div>
        </section>
        <section class="dados">
          <h1 v-if="falecido && falecido.nome_social">{{ falecido.nome_social }}</h1>
          <h1 v-else-if="falecido && falecido.nome">{{ falecido.nome }}</h1>
          <div class="date">
            <div class="star">
              <img src="@/assets/images/icons/star.png" alt="Star icon" />
            </div>
            <h2 v-if="falecido && falecido.data_nascimento">
              {{ formatDate(falecido.data_nascimento) }}
            </h2>
            <div class="cross">
              <img src="@/assets/images/icons/cross.png" alt="Cross icon" />
            </div>
            <h2 v-if="falecido && falecido.data_falecimento">
              {{ formatDate(falecido.data_falecimento) }}
            </h2>
          </div>
        </section>
        <v-card elevation="0" class="my-0">
          <v-tabs
            v-model="tab"
            :align-tabs="mdAndUp ? 'center' : undefined"
            background-color="white"
            color="#343F53"
            class="tabs"
            grow
            slider-color="#343F53"
          >
            <v-tab value="1" class="button biografia">
              <img
                src="@/assets/images/icons/book.png"
                alt=""
                class="tab-icon"
              />
              <p class="tab">Biografia</p>
            </v-tab>
            <v-tab value="2" class="button mensagens">
              <img
                src="@/assets/images/icons/chat.png"
                alt=""
                class="tab-icon"
              />
              <p class="tab">Mensagens</p>
            </v-tab>
            <v-tab value="3" class="button velorio">
              <img
                src="@/assets/images/icons/virtual.png"
                alt=""
                class="tab-icon"
              />
              <p class="tab">Velório virtual</p>
            </v-tab>
            <v-tab value="4" class="button servicos">
              <img
                src="@/assets/images/icons/servicos.png"
                alt=""
                class="tab-icon"
              />
              <p class="tab">Serviços</p>
            </v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab">
              <v-tabs-window-item value="1">
                <v-container fluid>
                  <v-row>
                    <v-col>
                      <h2 class="title">Biografia</h2>
                      <p class="msgobtuario">{{ despedida.obituario }}</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tabs-window-item>

              <v-tabs-window-item value="2">
                <v-container fluid>
                  <v-row>
                    <v-col class="mb-12">
                      <h2 class="title">Mensagens</h2>
                      <br />

                      <v-btn @click="enviarMensagem()" color="#343F53">
                        Enviar Mensagem
                      </v-btn>

                      <v-row>
                        <v-col
                          v-for="(item, i) in posts"
                          :key="i"
                          cols="12"
                          sm="6"
                          md="4"
                          class="d-flex card-container pb-0"
                        >
                          <div class="quote-icon">
                            <v-icon color="#343F53" size="100"
                              >mdi-format-quote-open</v-icon
                            >
                          </div>
                          <v-card
                            class="message-card elevation-3 flex-grow-1"
                            hover
                          >
                            <div v-if="item.imagem" class="message-image">
                              <img :src="item.imagem" alt="" class="image" />
                            </div>
                            <div
                              v-else
                              class="message-image d-flex align-center justify-center pb-0"
                            >
                              <v-icon color="blue-darken-1" size="150"
                                >mdi-image-area</v-icon
                              >
                            </div>

                            <v-card-text class="message-content">
                              <p class="message-text">{{ item.descricao }}</p>
                              <p v-if="item.nome" class="message-author">
                                - {{ item.nome }}
                              </p>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tabs-window-item>

              <v-tabs-window-item value="3">
                <v-container fluid>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <h2 class="title">Velório Virtual</h2>
                      <div class="stream-container">
                        <template
                          v-if="
                            despedida.apresentacao &&
                            despedida.apresentacao.camera
                          "
                        >
                          <div v-if="transmissaoEncerrada">
                            <div
                              style="
                                text-align: center;
                                margin-top: 2rem;
                                color: #c00;
                                font-size: 1.5rem;
                                font-weight: bold;
                              "
                            >
                              Transmissão Encerrada
                            </div>
                          </div>
                          <div v-else-if="transmissaoDesativada">
                            <div
                              style="
                                text-align: center;
                                margin-top: 2rem;
                                color: #c00;
                                font-size: 1.5rem;
                                font-weight: bold;
                              "
                            >
                              Transmissão Desativada
                            </div>
                          </div>
                          <div v-else-if="transmissaoEmBreve">
                            <div
                              style="
                                text-align: center;
                                margin-top: 2rem;
                                color: #888;
                                font-size: 1.5rem;
                                font-weight: bold;
                              "
                            >
                              Transmissão em breve
                            </div>
                          </div>
                          <div v-else-if="codigoSalvo">
                            <div class="video-player">
                              <video
                                id="video-player"
                                controls
                                autoplay
                                style="width: 100%"
                              ></video>
                            </div>
                          </div>
                          <div
                            v-else
                            style="text-align: center; margin-top: 2rem"
                          >
                            <v-btn
                              color="#343F53"
                              large
                              @click="queroParticipar"
                              >Quero Participar do Velório Virtual</v-btn
                            >
                          </div>
                        </template>
                        <template v-else>
                          <div
                            style="
                              text-align: center;
                              margin-top: 2rem;
                              color: #888;
                            "
                          >
                            Nenhuma transmissão disponível para esta despedida.
                          </div>
                        </template>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tabs-window-item>

              <v-tabs-window-item value="4">
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="8">
                      <h2 class="title">Serviços</h2>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3 class="subtitle">Velório</h3>
                      <p class="info">
                        <v-icon left>
                          <img
                            src="@/assets/images/icons/location.svg"
                            alt=""
                          />
                        </v-icon>
                        {{ despedida.local_velorio }} -
                        {{ formatDate(despedida.data_velorio) }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3 class="subtitle">Sepultamento</h3>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/location.svg" alt=""
                        /></v-icon>
                        {{ despedida.local_sepultamento }}
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/info.svg" alt=""
                        /></v-icon>
                        Jazigo: {{ despedida.localizacao_sepultado }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3 class="subtitle">
                        A Flor do Café - Floricultura - Campo Santo Parque das
                        Flores
                      </h3>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/location.svg" alt=""
                        /></v-icon>
                        Campo Santo Parque das Flores, Maceió - AL
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/book.svg" alt=""
                        /></v-icon>
                        Catálogo:
                        <a
                          href="https://catalogo.aflordocafe.com.br"
                          target="_blank"
                        >
                          https://catalogo.aflordocafe.com.br
                        </a>
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/phone.svg" alt=""
                        /></v-icon>
                        Telefone:
                        <a href="tel:+558233715258">(82) 3371-5258</a>
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/whatsapp.svg" alt=""
                        /></v-icon>
                        WhatsApp:
                        <a href="https://wa.me/5582999692001" target="_blank">(82) 99969-2001</a>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3 class="subtitle">
                        Memorial Flores - Floricultura - Memorial Parque Maceió
                      </h3>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/location.svg" alt=""
                        /></v-icon>
                        Cemitério Memorial Parque Maceió, Maceió - AL
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/book.svg" alt=""
                        /></v-icon>
                        Catálogo:
                        <a href="https://mkt.grupoparque.com.br/memorial-parque-floricultura" target="_blank">
                          https://mkt.grupoparque.com.br/memorial-parque-floricultura
                        </a>
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/phone.svg" alt=""
                        /></v-icon>
                        Telefone:
                        <a href="tel:+5582991743028">(82) 9174-3028</a>
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/whatsapp.svg" alt=""
                        /></v-icon>
                        WhatsApp:
                        <a href="https://wa.me/5582991743028" target="_blank">(82) 9174-3028</a>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3 class="subtitle">Flores Vidas</h3>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/location.svg" alt=""
                        /></v-icon>
                        Central de Velórios - Prado, Maceió - AL
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/book.svg" alt=""
                        /></v-icon>
                        Catálogo:
                        <a href="https://api.whatsapp.com/send?phone=55828000091700" target="_blank">
                          Flores Vidas
                        </a>
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/phone.svg" alt=""
                        /></v-icon>
                        Telefone:
                        <a href="tel:+5508000091700">0800 009 1700</a>
                      </p>
                      <p class="info">
                        <v-icon left
                          ><img src="@/assets/images/icons/whatsapp.svg" alt=""
                        /></v-icon>
                        WhatsApp:
                        <a href="https://wa.me/5508000091700" target="_blank">0800 009 1700</a>
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
        </v-card>
      </template>
    </div>

    <Footer />
  </div>

  <!-- Dialog de Participante -->
  <v-dialog v-model="dialogParticipante" persistent max-width="600px">
    <v-card>
      <v-toolbar color="#343F53">
        <v-card-title
          class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
        >
          <span style="color: white">Cadastro de participante</span>
        </v-card-title>
      </v-toolbar>
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="participante.nome"
            label="Nome"
            required
            :rules="[rules.required, rules.nome]"
          ></v-text-field>
          <v-text-field
            v-model="participante.telefone"
            label="Telefone"
            required
            v-mask="'(##) #####-####'"
            :rules="[rules.required, rules.telefone]"
          ></v-text-field>
          <v-text-field
            v-model="participante.email"
            label="E-mail"
            type="email"
            required
            :rules="[rules.email]"
          ></v-text-field>
          <v-checkbox
            v-model="participante.desejoReceberOfertas"
            label="Desejo receber ofertas e novidades"
          ></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#343F53"
          variant="text"
          @click="dialogParticipante = false"
          >Cancelar</v-btn
        >
        <v-btn
          color="#343F53"
          :loading="isLoadingParticipante"
          variant="flat"
          @click="confirmarParticipante"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="mensagem" persistent>
    <v-card style="max-width: 500px; width: 100%">
      <v-toolbar color="#343F53">
        <v-card-title
          class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
        >
          <span style="color: white">Digite uma nova mensagem</span>
        </v-card-title>
      </v-toolbar>
      <v-card-text>
        <v-col cols="12">
          <v-textarea
            v-model="post_new.msg"
            label="Mensagem"
            outlined
            counter="160"
            required
            rows="5"
            placeholder="Escreva uma breve homenagem..."
            no-resize
            maxlength="160"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="post_new.autor"
            label="Nome"
            :counter="35"
            maxlength="35"
            required
            class="custom-text-field"
          />
        </v-col>
        <v-col cols="12">
          <v-file-input
            v-model="post_new.img"
            label="Foto de anexo"
            hide-details
            accept="image/*"
            class="custom-file-input"
          ></v-file-input>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#343F53"
          variant="text"
          :disabled="isLoadingMensagem"
          @click="mensagem = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="#343F53"
          :disabled="isLoadingMensagem"
          :loading="isLoadingMensagem"
          variant="flat"
          @click="newMensagem()"
        >
          Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
* {
  font-family: "Sora", sans-serif;
}

.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(
    100vh - 160px
  ); /* Adjust based on your navbar/footer height */
}

.loading-text {
  margin-top: 16px;
  color: #343f53;
  font-size: 1.1rem;
}

.banner {
  height: 30vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;
}

.banner div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.banner div img {
  border-radius: 100%;
  width: 260px;
  height: 260px;
  position: absolute;
  bottom: 0;
  transform: translateY(50%);
  object-fit: cover;
}

.dados {
  margin-top: 8rem;
  margin-bottom: 2rem;
}

.dados h1 {
  text-align: center;
  color: #343f53;
  font-weight: 900;
  font-size: 50px;
}

.date {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.star,
.cross {
  display: flex;
  align-items: center;
  justify-content: center;
}

.star img,
.cross img {
  width: 20px;
}

.cross {
  margin-left: 1rem;
}

.date h2 {
  text-align: center;
  color: #343f53;
  font-weight: 300;
  font-size: 20px;
}

.v-card {
  margin: 2rem auto;
  max-width: 1000px;
  min-height: 30vh;
}

.tab-icon {
  width: 22px;
  margin-right: 0.5rem;
}

.title {
  color: #343f53;
  font-size: 2.6rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  display: inline-block;
  position: relative;
  padding-bottom: 0.1rem;
}

.title::after {
  content: "";
  display: block;
  width: 100%;
  height: 3px;
  background-color: #343f53;
  position: absolute;
  bottom: 0;
  left: 0;
}

.tab {
  color: #343f53;
  font-size: 1.2rem;
  letter-spacing: 0;
}

.msgobtuario {
  margin-top: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #343f53;
  font-size: 1.2rem;
}

.v-tabs .v-tab {
  font-size: 1rem;
  font-weight: 500;
  text-transform: none;
  display: flex;
  align-items: center;
  border-radius: 6px !important;
  padding: 0 2rem;
  margin-left: 0.4rem;
  border: 1px solid #343f53;
}

.button:hover {
  background-color: #343f53;
}

.button:hover p {
  color: #fff;
}

.biografia:hover img {
  content: url("@/assets/images/icons/book_white.png");
}

.mensagens:hover img {
  content: url("@/assets/images/icons/chat_white.png");
}

.velorio:hover img {
  content: url("@/assets/images/icons/virtual_white.png");
}

.servicos:hover img {
  content: url("@/assets/images/icons/servicos_white.png");
}

.message-card {
  border-radius: 8px;
  background-color: white;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  border: 1px solid #e9ecef;
  height: 320px;
  position: relative; /* necessário para posicionar o ícone */
  padding-top: 32px; /* espaço extra para não sobrepor conteúdo */
}

.message-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.message-image {
  padding: 1rem;
  height: 180px;
  overflow: hidden;
}

.message-image .image {
  width: 100%;
  height: 150px;
  border-radius: 4px;
  object-fit: cover;
}

.message-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: 200px;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.card-container {
  position: relative;
  padding-left: 18px;
}

.quote-icon {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 36px;
  height: 36px;
  z-index: 2;
  opacity: 0.85;
  transform: translateX(-50%);
}

.quote-icon v-icon {
  width: 100%;
  height: 100%;
}

.message-text {
  color: #343f53;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  flex-grow: 1;
  height: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
}

.message-author {
  color: #6c757d;
  font-size: 0.9rem;
  font-style: italic;
  text-align: right;
  margin-top: 0.5rem;
}

.video-card {
  border-radius: 12px;
  overflow: hidden;
}

.video-frame {
  border-radius: 12px;
}

.subtitle {
  font-size: 1.6rem;
  font-weight: 600;
  color: #343f53;
}

.info {
  font-size: 1rem;
  font-weight: 400;
  color: #343f53;
  margin-bottom: 0.4rem;
}

a {
  color: #343f53;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .dados {
    margin-top: 5rem;
    margin-bottom: 1rem;
  }
  .dados h1 {
    font-size: 1.4rem;
  }
  .banner {
    height: 20vh;
  }
  .banner div img {
    width: 160px;
    height: 160px;
  }
  .button p {
    display: none;
  }
  .v-tabs .v-tab:last-child {
    margin-right: 0.4rem;
  }
  .tab-icon {
    width: 18px;
    margin-right: 0;
  }
  .title {
    font-size: 1.6rem;
  }
  .subtitle {
    font-size: 1.4rem;
  }
  .info {
    font-size: 0.8rem;
  }
}
</style>
